// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b_XJ_PL8axQ1yYbe{min-width:100%}.b_XJ_PL8axQ1yYbe .IBwMqqfBLwHznYP8{display:flex;justify-content:space-between;flex-direction:row;column-gap:8px;align-items:center}.b_XJ_PL8axQ1yYbe .IBwMqqfBLwHznYP8 .b6HIhsALBuAzP1iW{display:flex;flex-direction:row;column-gap:8px;width:100%;align-items:center;text-overflow:ellipsis}.b_XJ_PL8axQ1yYbe .IBwMqqfBLwHznYP8 .b6HIhsALBuAzP1iW .jP2wHQTU8K8iAEQY{height:100%}.T8ddyYUmCRM8bUm9{min-width:180px}.xMeAOnqTv0JdeR3o{white-space:pre-wrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"singleGoalHeader": `b_XJ_PL8axQ1yYbe`,
	"goalNameRow": `IBwMqqfBLwHznYP8`,
	"goalName": `b6HIhsALBuAzP1iW`,
	"goalIcon": `jP2wHQTU8K8iAEQY`,
	"optionsMenu": `T8ddyYUmCRM8bUm9`,
	"lineBreak": `xMeAOnqTv0JdeR3o`
};
export default ___CSS_LOADER_EXPORT___;
